// extracted by mini-css-extract-plugin
export default {"container":"ProfileCard_container__HH8D+","star":"ProfileCard_star__hTrqX"};